module.exports = __webpack_public_path__ + "media/newstart.a8833efc.mp3";